
import { Profile } from "@/hooks/useProfileData";
import { User, Mail, Phone, Crown } from "lucide-react";

interface PersonalInfoDisplayProps {
  profile: Profile;
}

export function PersonalInfoDisplay({ profile }: PersonalInfoDisplayProps) {
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <label className="text-sm font-medium text-white/70">Name</label>
        <div className="flex gap-2 items-center">
          <User className="h-5 w-5 text-white/70" />
          <span className="flex-1 text-white">{profile.full_name}</span>
        </div>
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-white/70">Email</label>
        <div className="flex gap-2 items-center">
          <Mail className="h-5 w-5 text-white/70" />
          <span className="flex-1 text-white">{profile.email}</span>
        </div>
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-white/70">Phone</label>
        <div className="flex gap-2 items-center">
          <Phone className="h-5 w-5 text-white/70" />
          <span className="flex-1 text-white">{profile.phone}</span>
        </div>
      </div>

      <div className="space-y-2">
        <label className="text-sm font-medium text-white/70">Specialisation</label>
        <div className="flex gap-2 items-center">
          <Crown className="h-5 w-5 text-white/70" />
          <span className="flex-1 text-white">{profile.specialization}</span>
        </div>
      </div>
    </div>
  );
}
